import http from './api'
import config from './config'

export interface AiImageProvider {
  id: string
  name: string
  pricePerImage: number
  currency: string
  description?: string
  enabled: boolean
}

export interface GenerateDishImagesResult {
  menuItemId: string
  aiGeneratedImageId: string
}

class AiImageService {
  getAiImageUrl(id: string): string {
    return `${config.baseURL}/api/ai-images/${id}`
  }

  async getProviders(restaurantId: string): Promise<AiImageProvider[]> {
    const response = await http.get<AiImageProvider[]>(
      `/restaurants/${restaurantId}/menus/ai-image-providers`
    )
    return response.data
  }

  async generateDishImages(
    restaurantId: string,
    menuId: string,
    body: { providerId: string; menuItemIds?: string[] }
  ): Promise<GenerateDishImagesResult[]> {
    const response = await http.post<GenerateDishImagesResult[]>(
      `/restaurants/${restaurantId}/menus/${menuId}/generate-dish-images`,
      body
    )
    return response.data
  }

  async createAiImagePayment(
    restaurantId: string,
    menuId: string,
    body: { providerId: string; menuItemIds?: string[] }
  ): Promise<{ clientSecret: string; amountCents: number; currency: string }> {
    const response = await http.post<{
      clientSecret: string
      amountCents: number
      currency: string
    }>(
      `/restaurants/${restaurantId}/menus/${menuId}/ai-image-create-payment`,
      body
    )
    return response.data
  }
}

const aiImageService = new AiImageService()
export default aiImageService
